import { render, staticRenderFns } from "./UsarComo.vue?vue&type=template&id=932c407e&"
import script from "./UsarComo.vue?vue&type=script&lang=js&"
export * from "./UsarComo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports